import { defineStore } from 'pinia';
import { ref } from 'vue';
import { type ICatalogData, Locale, User, UserGroup } from '@/entities/user';
import useStore from '@/store';

export default defineStore('user', () => {
  const user = ref<User>();
  const userGroups = ref<UserGroup[]>([]);
  // const catalogs = ref<ICatalogData[]>([]);
  const cmsLocale = ref<string>('en-US');
  // const locales = ref<Locale[]>([]);
  const rootStore = useStore();
  const messages = ref<{
    [key: string]: string;
  }>({});

  function escapeHTML(str: string) {
    return str.replace(/@/g, "{'@'}");
  }

  return {
    user,
    userGroups,
    cmsLocale,
    // locales,
    messages,
    // catalogs,

    async init() {
      user.value = await this.getActiveUser();
      if (user.value) {
        // catalogs.value = await this.getUserCatalogs();
        // void this.getLocales();
        userGroups.value = await this.getUserGroups(user.value.id);
        messages.value = {};

        const aemLocale = document.documentElement.lang;
        cmsLocale.value = aemLocale;

        if (aemLocale === 'en-zz') {
          cmsLocale.value = 'en-US';
        } else if (aemLocale === 'es-la') {
          cmsLocale.value = 'es-XL';
        } else if (aemLocale.includes('-')) {
          const [lang, region] = aemLocale.split('-');
          if (lang && region) {
            cmsLocale.value = `${lang}-${region.toUpperCase()}`;
          }
        }

        let almLocale = cmsLocale.value;
        if (cmsLocale.value === 'en-GB' || cmsLocale.value === 'en-AU' || cmsLocale.value === 'en-CA') {
          almLocale = 'en-US';
        }

        if (user.value && almLocale.toLowerCase() !== user.value.contentLanguage.toLowerCase()) {
          await this.setLocale(almLocale);
        }

        const localeStrings = await this.getLocaleStrings(cmsLocale.value);
        localeStrings.forEach((item) => {
          messages.value[item.id] = escapeHTML(item.value);
        });
      }
    },
    async getActiveUser() {
      return rootStore.apiService.user.fetchUser().then(async (data) => {
        if (data && data.user) {
          const user = new User(data.user);

          if (data.referralCode) {
            user.referralCode = data.referralCode;
          }

          const userAvatars = await rootStore.apiService.leaderboard.fetchUserAvatars([user.id]);
          if (userAvatars.length) {
            user.avatarUrl = `${rootStore.appBaseDomain}${userAvatars[0].imageUrl}`;
          }

          return user;
        }
      });
    },
    async getUserGroups(userId: string) {
      return (await rootStore.primeService.user.fetchUserGroups(userId)).map((data) => new UserGroup(data));
    },
    // async getUserCatalogs() {
    //   return await rootStore.primeService.user.fetchUserCatalogs();
    // },
    // async getLocales() {
    //   locales.value = await rootStore.apiService.user
    //     .fetchLocales(catalogs.value.map((catalog) => catalog.id))
    //     .then((locales) => locales.map((data) => new Locale(data)));
    // },
    async getLocaleStrings(locale: string) {
      return await rootStore.apiService.user.fetchLocale(locale);
    },
    async setLocale(locale: string) {
      if (user.value) {
        await rootStore.primeService.user.patchUser(user.value.id, { contentLocale: locale });
      }
    }
  };
});
